import React from 'react';

const sesionaDescription = () => {
    return (
        <div style={{ paddingBottom: '100px', width: '100%' }}>
            <div className='ui grid'>
                <div className="centered row">
                    <div className="sixteen wide column centered">
                        <h1 className="ui header">Sesiona</h1>
                    </div>
                </div>
                <div className='row'>
                    <div className='sixteen wide column'>
                        <h2 className="ui header">Description</h2>
                        <p>
                            <strong>Sesiona</strong> is a full-stack SaaS platform designed specifically for independent professionals
                            (psychologists, doctors, lawyers, coaches, etc.) to streamline their administrative tasks.
                            It provides a comprehensive solution for managing appointments, payments, and client records
                            with a focus on the Chilean and Mexican markets.
                        </p>

                        <h3 className="ui header">Core Features</h3>
                        <div className="ui bulleted list">
                            <div className="item"><strong>Agenda & Scheduling:</strong> Online booking system with Google Calendar integration.</div>
                            <div className="item"><strong>Automated Payments:</strong> Integrated with Transbank WebPay Plus for secure card payments.</div>
                            <div className="item"><strong>Electronic Billing (SII):</strong> Automatic generation of "Boletas de Honorarios" and "Facturas" following Chilean tax regulations (SII).</div>
                            <div className="item"><strong>Clinical Records:</strong> Digital fichas for client management and session history.</div>
                            <div className="item"><strong>Digital Storefront (Vitrina):</strong> Sell digital products like ebooks, courses, and workshops.</div>
                            <div className="item"><strong>Automated Reminders:</strong> Notifications via Email and WhatsApp to reduce no-shows.</div>
                        </div>

                        <h3 className="ui header">Technology Stack</h3>
                        <div className="ui bulleted list">
                            <div className="item"><strong>Frontend:</strong> React 18+, Vite, Tailwind CSS 3, React Router.</div>
                            <div className="item"><strong>Backend:</strong> Node.js + Express (API server).</div>
                            <div className="item"><strong>Database:</strong> PostgreSQL via Prisma ORM (hosted on Supabase).</div>
                            <div className="item"><strong>Auth:</strong> JWT-based authentication.</div>
                            <div className="item"><strong>Integrations:</strong> Google Calendar API, Transbank WebPay, SII (Tax integration).</div>
                        </div>

                        <p style={{ marginTop: '20px' }}>
                            The application features a modern, bold, and vibrant design with glassmorphism elements,
                            using a primary palette of electric violet and hot pink.
                        </p>
                    </div>
                </div>
                <div className='centered row'>
                    <div className="sixteen wide column center aligned">
                        <a href="https://www.sesiona.site" target="_blank" rel="noopener noreferrer">
                            <div className='ui small primary button'>
                                <i className='external alternate icon'></i> Check it out
                            </div>
                        </a>
                        <a href="https://github.com/jomavera/sesiona" target="_blank" rel="noopener noreferrer">
                            <div className='ui small black button'>
                                <i className='github icon'></i> Repo
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default sesionaDescription;
